import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockSliderModule } from '@common/components/feature-part/block-slider/block-slider.module';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { PaymentDetailS02P020Component } from './payment-detail-s02-p020.component';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentDetailsPaidServiceComponent } from './payment-details-paid-service/payment-details-paid-service.component';
import { PaymentDetailsSummaryComponent } from './payment-details-summary/payment-details-summary.component';

@NgModule({
  declarations: [PaymentDetailS02P020Component, PaymentDetailsSummaryComponent, PaymentDetailsPaidServiceComponent],
  exports: [PaymentDetailS02P020Component],
  imports: [CommonModule, BlockSliderModule, StaticMsgModule, AmountFormatModule, TranslateModule],
})
export class PaymentDetailS02P020Module {}
